import { useState } from 'react'
import { useQuery } from '@apollo/client/react'
import {
  PortalBusinessRecordsDocument,
  type PortalBusinessRecordsQuery,
} from '@/graphql/generated/graphql'
import { DEFAULT_PAGE_SIZE } from '@/shared/constants'

export type BusinessRecord =
  PortalBusinessRecordsQuery['portalBusinessRecords']['items'][number]

export const BUSINESS_RECORDS_PAGE_SIZE = DEFAULT_PAGE_SIZE

/**
 * Historial (records) de un negocio, paginado por página.
 */
export function useBusinessRecords(businessId: string | undefined) {
  const [page, setPage] = useState(1)

  const { data, loading, error, refetch } = useQuery(PortalBusinessRecordsDocument, {
    variables: {
      businessId: businessId ?? '',
      take: BUSINESS_RECORDS_PAGE_SIZE,
      skip: (page - 1) * BUSINESS_RECORDS_PAGE_SIZE,
    },
    skip: !businessId,
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  })

  return {
    records: data?.portalBusinessRecords.items ?? [],
    totalItems: data?.portalBusinessRecords.totalItems ?? 0,
    page,
    setPage,
    pageSize: BUSINESS_RECORDS_PAGE_SIZE,
    loading,
    error,
    refetch,
  }
}
